export {
  HotelGalleryPhotoViewerComponent,
  HotelGalleryPhotoViewerComponentEditable,
} from './HotelGalleryPhotoViewerComponent';
